<template>
  <div :style="contactUsBannerStyle">
    <img
      v-if="lang"
      :src="'/img/kontakt_' + lang + '.jpg'"
    />
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ContactBanner',

  computed: {
    ...mapFields(Object.keys(state)),

    contactUsBannerStyle () {
      return {
        position: 'sticky',
        bottom: '0',
      }
    }
  }
}
</script>

<style>

</style>
